import { object, string } from 'yup'

export const loginSchema = object().shape({
  email: string()
    .required('Email is required')
    .email('Incorrect email address'),
  password: string().required('Password is required')
  // rememberMe: boolean()
  //   .required('The terms and conditions must be accepted.')
  //   .oneOf([true], 'The terms and conditions must be accepted.')
})
